import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
export var TinyLoader = function () {
    var classNames = namespacedClassnames('tiny-loader');
    return React.createElement("div", { className: classNames });
};
//# sourceMappingURL=tiny-loader.js.map